import { z } from 'zod';
import { themeModes, themePalettes } from '../domain/appearance.js';
/**
 * Body of `PUT /settings/appearance`. Both fields are required — the client
 * always knows its full current appearance, so a full-document write keeps the
 * endpoint in line with the other settings routes and avoids partial-merge
 * ambiguity.
 */
export const appearancePreferenceSchema = z
    .object({
    themePalette: z.enum(themePalettes),
    themeMode: z.enum(themeModes),
})
    .strict();
//# sourceMappingURL=appearance.js.map